import { render, staticRenderFns } from "./Partner_Start.vue?vue&type=template&id=5a4e66fe&scoped=true&"
import script from "./Partner_Start.vue?vue&type=script&lang=js&"
export * from "./Partner_Start.vue?vue&type=script&lang=js&"
import style0 from "./Partner_Start.vue?vue&type=style&index=0&id=5a4e66fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4e66fe",
  null
  
)

export default component.exports